import { render, staticRenderFns } from "./OfertaManopera.vue?vue&type=template&id=530bee84&scoped=true"
import script from "./OfertaManopera.vue?vue&type=script&lang=js"
export * from "./OfertaManopera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bee84",
  null
  
)

export default component.exports